import http from '../../http'
export default {
    page: (params) => {
        return http.post('activityservice/schedulemanage/page', params)
    },
    list: (params) => {
        return http.get('activityservice/schedulemanage/list', params)
    },
    parent: (params) => {
        return http.get('activityservice/schedulemanage/parent', params)
    },
    add: (params) => {
        return http.post('activityservice/schedulemanage/save', params)
    },
    update: (params) => {
        return http.post('activityservice/schedulemanage/update', params)
    },
    del: (params) => {
        return http.post('activityservice/schedulemanage/remove', params)
    },
    delAll: (params) => {
        return http.post('activityservice/schedulemanage/batchremove', params)
    }
}
